import { render, staticRenderFns } from "./PatientMeasurementTable.vue?vue&type=template&id=bfce4006&scoped=true&"
import script from "./PatientMeasurementTable.vue?vue&type=script&lang=js&"
export * from "./PatientMeasurementTable.vue?vue&type=script&lang=js&"
import style0 from "./PatientMeasurementTable.vue?vue&type=style&index=0&id=bfce4006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce4006",
  null
  
)

export default component.exports